module.exports = __webpack_public_path__ + "img/Colony POI Icon.6c8bdd4a.svg";